// Cross-page cache of the last proactive medication suggestion shown to the
// patient (PROACTIVE_SUGGESTIONS_PLAN.md). Proactive suggestions render on the
// Dashboard only (DASHBOARD_DND_AND_ACTIVITY_PLAN.md D-CHAT-1), but a user can
// still leave a thumbs-down on the Chat page's general feedback footer about a
// suggestion they saw earlier. Without this, that feedback carries no record of
// which medication/regimen/schedule prompted the complaint. DashboardPane keeps
// this in sync with its `suggestion` state; ChatPane reads it as a fallback when
// no in-flight capture proposal is pending.

import type { ProactiveSuggestion } from "./api.js";

const key = (patientId: string): string => `lastSuggestion:${patientId}`;

export function cacheLastSuggestion(patientId: string, suggestion: ProactiveSuggestion | null): void {
  try {
    if (suggestion) sessionStorage.setItem(key(patientId), JSON.stringify(suggestion));
    else sessionStorage.removeItem(key(patientId));
  } catch {
    /* sessionStorage unavailable — caching is best-effort */
  }
}

export function readLastSuggestion(patientId: string): ProactiveSuggestion | null {
  try {
    const raw = sessionStorage.getItem(key(patientId));
    return raw ? (JSON.parse(raw) as ProactiveSuggestion) : null;
  } catch {
    return null;
  }
}
